import React, { useEffect, useState } from 'react'
import { Button, Col, Drawer, Form, notification, Row, Card, Input } from 'antd'
import { connect } from 'react-redux'
import _ from 'lodash'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { commissionClaimNewFxn } from '../actions'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import lodash from 'lodash'
import { CustomInput, getcurrencySymbols, InputBox } from '../../../components/_utils/appUtils'

let initState = {
  visible: false,
  selectedCommissions: []
}
const AddClaimByStudentComponent = (props) => {
  let dispatch = useDispatch()
  let {
    visible,
    onClose,
    form: { getFieldDecorator },
    record,
    universityData,
    commissionCurrency,
    refreshFxn
  } = props
  const calculateNetAmount = (amounts, item) => {
    const amount = parseFloat(amounts) || 0
    const bonus = parseFloat(item.bonus) || 0
    const advance = parseFloat(item.advance) || 0
    return (amount + bonus - advance).toFixed(2)
  }
  const [items, setItems] = useState({
    bonus: {},
    advance: {}
  })
  let [commissionList, setCommissionList] = useState([])
  const [amountVals, setAmountVals] = useState({})
  let [universityInvoice, setUniversityInvoice] = useState({})
  let [refreshKey, setRefreshKey] = useState(moment())
  let [state, setState] = useState(initState)
  const [totalBonusSum, setTotalBonus] = useState(0)
  const [totalAdvanceSum, setTotalAdvance] = useState(0)
  const [totalCommissionSum, setTotalCommission] = useState(0)
  const [commissionNet, setCommissionNet] = useState(0)
  useEffect(() => {
    if (record && record.length) {
      const initialAmounts = {}
      record.forEach((item, idx) => {
        initialAmounts[idx] = item.amount
      })
      setAmountVals(initialAmounts)
    }

  }, [record])

  const handleAmountChange = (index, value) => {
    setAmountVals(prev => ({
      ...prev,
      [index]: parseInt(value)
    }))
  }

  const handleChange = (field, index, value) => {
    setItems(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [index]: value
      }
    }))
  }
  // useEffect(() => {
  //   setTimeout(() => {
  //     setFieldsValue({claimReceivedDate: moment()})
  //   }, 500)
  //   setCommissionList([commissionList, record])
  // }, [])


  let chooseDocument = (e) => {
    let { files } = e.target
    if (files && files.length) {
      setUniversityInvoice(files[0])
    } else {
      setUniversityInvoice(null)
    }
  }

  let inputTypes = {
    fields: [
      {
        key: 'claimDate',
        label: 'Claim Date',
        placeholder: 'Claim Date',
        type: 'date',
        required: true,
        span: 8
      },
      {
        key: 'universityInvoice',
        label: 'University Statement',
        placeholder: 'University Statement',
        type: 'file',
        required: true,
        span: 16,
        customField: (
          <InputBox title={`* University Statement`} customStyle={{ marginTop: 5 }}>
            <Form.Item>
              <Input type={'file'} name={'universityInvoice'} required={true}
                     key={refreshKey}
                     style={{ marginTop: 4 }}
                     id={'universityInvoice'} className={'form-control'}
                     onChange={(e) => {
                       chooseDocument(e)
                     }} />
            </Form.Item>
          </InputBox>
        )
      },
      {
        key: 'details',
        label: '',
        placeholder: 'Details',
        span: 24
      }
    ]
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const handleStatusUpdate = (e) => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let commissions = []
        let totalCommission = 0
        let totalAmount = 0
        const studentIds = new Set()
        const receiveStudentIds = new Set()
        _.each(commissionList, (item) => {
          item.commissionId = item._id
          totalAmount += item.amount || 0
          commissions.push({
            commissionId: item._id, amount: item.amount
          })
          if (item.studentId) {
            studentIds.add(item.studentId)
          }
        })
        valData.totalStudents = studentIds.size
        valData.commissions = commissions
        valData.currency = commissionCurrency
        valData.universityId = universityData.universityId
        valData.totalCommission = totalAmount

        //total of all the claiming commission
        valData.totalCommissionSum = totalCommissionSum
        valData.totalBonusSum = totalBonusSum
        valData.totalAdvanceSum = totalAdvanceSum
        valData.netCommissionSum = commissionNet

        let fd = new FormData()
        fd.append('obj', JSON.stringify(valData))
        if (universityInvoice && universityInvoice.name) {
          fd.append('universityInvoice', universityInvoice)
        }
        let resp = await dispatch(commissionClaimNewFxn(fd))
        if (resp && resp.success) {
          onClose()
          setRefreshKey(moment())
          refreshFxn()
        }
      } else {
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }


  const events = {
    showVisibleCommission: () => {
      let { agentId } = record
      let selectedCommissions = []
      lodash.each(commissionList, (item) => {
        if (item && item._id) {
          selectedCommissions.push(item._id)
        }
      })
      setState({
        ...state,
        visible: true,
        selectedCommissions
      })
    },
    hideVisibleCommission: () => {
      setState({
        ...state,
        visible: false
      })
    },
    chooseCommission: (data) => {
      let commissionListTemp = lodash.clone(commissionList)
      let findCom = lodash.find(commissionListTemp, (item) => {
        return item._id == data._id
      })
      if (findCom) {
        notification.warning({ message: 'Commission already exists.' })
      } else {
        commissionListTemp.push(data)
        setCommissionList(commissionListTemp)

      }
    },
    removeStu: (commissionId) => {
      let commissionListTemp = lodash.clone(commissionList)
      commissionListTemp = lodash.reject(commissionListTemp, (item) => {
        return item._id == commissionId
      })
      setCommissionList(commissionListTemp)
    },
    updateRecord: (data) => {
      let commissionListTemp = lodash.clone(commissionList)
      let findCom = lodash.find(commissionListTemp, (item) => {
        return item._id == data._id
      })
      if (findCom) {
        findCom.amount = parseFloat(data.amount)
        setCommissionList(commissionListTemp)
      }
    }
  }
  useEffect(() => {
    if (record && record.length > 0) {
      const updated = record.map((item, index) => {
        const rawBonus = items.bonus[index]
        const rawAdvance = items.advance[index]
        const rawAmount = amountVals[index]

        const bonus = !isNaN(parseFloat(rawBonus)) ? parseFloat(rawBonus) : 0
        const advance = !isNaN(parseFloat(rawAdvance)) ? parseFloat(rawAdvance) : 0
        const amount = !isNaN(parseFloat(rawAmount)) ? parseFloat(rawAmount) : 0
        const netAmount = amount + bonus - advance
        return {
          ...item,
          commission: amount,
          bonus,
          advanceCommission: advance,
          amount: netAmount
        }
      })
      setCommissionList(updated)
    }
  }, [record, items.bonus, items.advance, amountVals])


  useEffect(() => {
    let bonusSum = record.reduce((sum, item) => sum + Number(item.bonus || 0), 0)
    let advanceSum = record.reduce((sum, item) => sum + Number(item.advanceCommission || 0), 0)
    let commissionSum = record.reduce((sum, item) => sum + Number(item.amount || 0), 0)

    // ---- Commission from amountVals ----
    if (amountVals) {
      if (typeof amountVals === 'object') {
        commissionSum = Object.values(amountVals).reduce(
          (sum, val) => sum + Number(val || 0),
          0
        )
      } else {
        commissionSum = Number(amountVals || 0)
      }
    }

    // ---- Bonus ----
    if (items.bonus) {
      if (typeof items.bonus === 'object') {
        bonusSum = Object.values(items.bonus).reduce(
          (sum, val) => sum + Number(val || 0),
          0
        )
      } else {
        bonusSum = Number(items.bonus || 0)
      }
    }

    // ---- Advance ----
    if (items.advance) {
      if (typeof items.advance === 'object') {
        advanceSum = Object.values(items.advance).reduce(
          (sum, val) => sum + Number(val || 0),
          0
        )
      } else {
        advanceSum = Number(items.advance || 0)
      }
    }

    setTotalBonus(bonusSum)
    setTotalAdvance(advanceSum)
    setTotalCommission(commissionSum)
    setCommissionNet(commissionSum + bonusSum - advanceSum)
  }, [items, amountVals, record])  // ✅ Correct dependency array

  useEffect(() => {
    let bonusSum = record.reduce((sum, item) => sum + Number(item.bonus || 0), 0)
    let advanceSum = record.reduce((sum, item) => sum + Number(item.advanceCommission || 0), 0)
    let commissionSum = record.reduce((sum, item) => sum + Number(item.amount), 0)
    setTotalBonus(bonusSum)
    setTotalAdvance(advanceSum)
    setTotalCommission(commissionSum)
    setCommissionNet(commissionSum + bonusSum - advanceSum)
  }, [])

  return (
    <>
      <Drawer
        visible={visible}
        onClose={onClose}
        title={`Claim Commission`}
        width={'80%'}>
        <div className='form-box commissionBox'>
          <div className='card unizportal'>
            <Form onSubmit={handleStatusUpdate}>
              <Row gutter={16} className={'wrapBox'}>
                <Col span={6}>
                  <div className={`universityParentBox`}>
                    <Card className={'commissionUniInfo'}>
                      {universityData && universityData.universityName ?
                        <>
                          {universityData && universityData.smallLogo && universityData.smallLogo.url ?
                            <div className={'uniLogo'}>
                              <img src={universityData.smallLogo.url} />
                            </div> : null}
                          <div className={'studentInfoBox'}>
                            <div className={'uniName'}>
                              {universityData.universityName}
                            </div>
                          </div>
                        </>
                        : null}
                    </Card>
                  </div>
                </Col>
                <Col span={10}>
                  <Card size={'small'}>
                    {inputTypes.fields.map((item, key) => {
                      return (!item.hidden && <Col span={item.span} key={key}>{item.customField ? item.customField :
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout} />}
                      </Col>)
                    })}
                  </Card>
                </Col>
                <Col span={8}>
                  <Card size={'small'} className={'commission-amount-box'}>
                    <div className='card-row'>
                      <div className='commission-label-new'><b>Total Commission</b></div>
                      <div
                        className='commission-value-new'> {totalCommissionSum}</div>
                    </div>
                    <div className='card-row'>
                      <div className='label-new'><b>Total Bonus</b></div>
                      <div className='value-new'>
                        {/*{totalBonus ? `${getcurrencySymbols[commissionCurrency]} ${totalBonus}` : '0'}*/}
                        {totalBonusSum ? `${totalBonusSum}` : '0'}
                      </div>
                    </div>
                    <div className='card-row'>
                      <div className='label-new'><b>Total Advance</b></div>
                      <div className='value-new'>
                        {/*{totalAdvance ? `${getcurrencySymbols[commissionCurrency]} ${totalAdvance}` : '0'}*/}
                        {totalAdvanceSum ? `${totalAdvanceSum}` : '0'}
                      </div>
                    </div>
                    <div className='card-row'>
                      <p className='label-new'><b>Commission Net Amount</b></p>
                      <p className='value-new'>{getcurrencySymbols[commissionCurrency]} {commissionNet}</p>
                    </div>
                  </Card>

                </Col>
                <Col span={24}>
                  <div className={'commissionListBox'}>
                    {record && record.length ? record.map((item, index) => {
                      return <>
                        <div className={`commissionParentBox`}>
                          <Card className={'commissionUniInfo'}>
                            <div style={{ marginBottom: '8px' }}>
                            </div>
                            {item.universityId ?
                              <div className={'row'}>
                                <div className={'studentBox flexStart'}>

                                  <div className={'studentInfo'} style={{ paddingLeft: 10 }}>

                                    <div className={'uniName'}>
                                      {item.courseName}
                                    </div>
                                    <div className={'courseInfo'}>
                                      <b>Student Name:</b> {item.name}
                                    </div>
                                    {item && item.commissionDetails && item.commissionDetails ?
                                      <div className={'courseInfo'}>
                                        Student ID : {item.commissionDetails.offerLetterStudentId}
                                      </div> : null}
                                    {item && item.commissionDetails && item.commissionDetails ?
                                      <div className={'courseInfo'}>
                                        App ID : {item.appId}
                                      </div> : null}
                                  </div>
                                </div>
                                <div className={'studentBox flexStart'} style={{ width: '23%' }}>
                                  <div className={'studentInfo'}>
                                    <div className={'uniName'}> {item.semester}
                                    </div>
                                    <div className={'courseInfo'}>
                                      Semester Fees : {item.semesterFee} {item.currency}
                                    </div>
                                    <div className={'courseInfo'}>
                                      Offer S. ID : {item.commissionDetails.offerLetterStudentId}
                                    </div>
                                  </div>
                                </div>

                                <div className={'studentBox inputFlex'}>
                                  <div className='form-group student-group mt0'>
                                    <CustomInput
                                      title='Commission'
                                      type='text'
                                      customClass={'mt0'}
                                      leftContent={item.currency}
                                      value={amountVals[index] || ''}
                                      onChange={(e) => handleAmountChange(index, e)}
                                    />
                                  </div>
                                </div>

                                <div className={'studentBox inputFlex'}>
                                  <div className='form-group student-group mt0'>
                                    <CustomInput
                                      title='Bonus'
                                      type='text'
                                      leftContent={item.currency}
                                      customClass={'mt0'}
                                      value={items.bonus[index] || ''}
                                      onChange={e => handleChange('bonus', index, e)}
                                    />
                                  </div>
                                </div>

                                <div className={'studentBox inputFlex'} style={{ width: '17%' }}>
                                  <div className='form-group student-group mt0'>
                                    <CustomInput
                                      title='Advance'
                                      type='text'
                                      customClass={'mt0'}
                                      leftContent={item.currency}
                                      value={items.advance[index] || ''}
                                      onChange={e => handleChange('advance', index, e)}
                                    />
                                    <div className='courseInfo mt-1' style={{ textAlign: 'right' }}>
                                      <b>Net Commission Amt:</b> {calculateNetAmount(amountVals[index], {
                                      bonus: items.bonus[index] || '0',
                                      advance: items.advance[index] || '0'
                                    })}
                                    </div>
                                  </div>
                                </div>

                              </div> : null}
                          </Card>
                        </div>
                      </>
                    }) : null}

                  </div>
                </Col>
                <Col span={4}>
                  <Form.Item>
                    <Button
                      type='primary' htmlType='submit' className={'btn mt20'}>
                      Claim Commission
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

          </div>
        </div>

      </Drawer>
    </>
  )
}

const AddClaimByStudent = Form.create()(AddClaimByStudentComponent)
const mapStateToProps = ({ global, router }) => ({
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddClaimByStudent)
